/** 사이트 통계 — 통계 › 방문·클릭 분석 (pages/todaymall/statistics). */
export default {
  'pages.siteAnalytics.tab.analysis': "방문·클릭 분석",
  'pages.siteAnalytics.tab.realtime': "실시간 현황",
  'pages.siteAnalytics.loadFailed': "통계를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
  'pages.siteAnalytics.notCollecting': "방문 수집이 꺼져 있습니다. 서버에서 사이트 통계 기능을 켜야 자료가 쌓입니다.",
  'pages.siteAnalytics.noDataYet': "아직 수집된 방문 자료가 없습니다. 수집을 켠 뒤 방문이 생기면 여기에 나타납니다.",
  'pages.siteAnalytics.firstDataDay': "방문 자료는 {date}부터 있습니다. 그 이전 기간은 비어 있습니다.",

  'pages.siteAnalytics.filter.today': "오늘",
  'pages.siteAnalytics.filter.last7': "최근 7일",
  'pages.siteAnalytics.filter.last30': "최근 30일",
  'pages.siteAnalytics.filter.last90': "최근 90일",
  'pages.siteAnalytics.filter.deviceAll': "전체 기기",
  'pages.siteAnalytics.filter.visitorAll': "신규·재방문 전체",
  'pages.siteAnalytics.filter.visitorNew': "신규 방문",
  'pages.siteAnalytics.filter.visitorReturning': "재방문",
  'pages.siteAnalytics.filter.compare': "비교 기간 {from} ~ {to} · 한국 시간 기준",
  'pages.siteAnalytics.filter.kst': "한국 시간 기준",
  'pages.siteAnalytics.view.chart': "그래프로 보기",
  'pages.siteAnalytics.view.table': "표로 보기",

  'pages.siteAnalytics.device.pc': "PC",
  'pages.siteAnalytics.device.mobile_web': "모바일 브라우저",
  'pages.siteAnalytics.device.android': "Android 앱",
  'pages.siteAnalytics.device.ios': "iOS 앱",

  'pages.siteAnalytics.kpi.uv': "방문자 수 (UV)",
  'pages.siteAnalytics.kpi.uv.tip': "기간 안에 방문한 서로 다른 방문자 수입니다. 로그인한 방문자는 계정으로, 아니면 브라우저·앱 단위로 셉니다. 페이지 하나만 열고 화면에 보이지도, 누르지도 않은 방문(자동 수집 프로그램)은 모든 지표에서 뺍니다.",
  'pages.siteAnalytics.kpi.pv': "페이지뷰 (PV)",
  'pages.siteAnalytics.kpi.pv.tip': "페이지(앱은 화면)를 연 횟수입니다. 검색어나 필터만 바꾼 것은 세지 않습니다.",
  'pages.siteAnalytics.kpi.avgDwell': "평균 체류 시간",
  'pages.siteAnalytics.kpi.avgDwell.tip': "방문 한 번에 화면이 실제로 보인 시간의 평균입니다. 다른 탭으로 가 있던 시간은 빼고 셉니다.",
  'pages.siteAnalytics.kpi.bounceRate': "이탈률",
  'pages.siteAnalytics.kpi.bounceRate.tip': "페이지를 하나만 보고 끝난 방문의 비율입니다. 낮을수록 좋습니다.",
  'pages.siteAnalytics.kpi.clicks': "총 클릭수",
  'pages.siteAnalytics.kpi.clicks.tip': "웹은 링크·버튼 클릭 전부, 앱은 장바구니·바로구매 버튼만 셉니다.",
  'pages.siteAnalytics.kpi.vsPrevious': "이전 기간 대비",
  'pages.siteAnalytics.kpi.noBaseline': "비교할 이전 자료 없음",

  'pages.siteAnalytics.duration.hm': "{h}시간 {m}분",
  'pages.siteAnalytics.duration.ms': "{m}분 {s}초",
  'pages.siteAnalytics.duration.s': "{s}초",
  'pages.siteAnalytics.unit.people': "{n}명",
  'pages.siteAnalytics.unit.times': "{n}회",

  'pages.siteAnalytics.trend.title': "UV / PV 추이",
  'pages.siteAnalytics.trend.uv': "UV",
  'pages.siteAnalytics.trend.pv': "PV",
  'pages.siteAnalytics.trend.note': "일별 UV는 그날의 방문자 수라서, 여러 날에 온 방문자는 날마다 세어집니다(합계가 기간 UV보다 큽니다).",
  'pages.siteAnalytics.trend.col.date': "날짜",

  'pages.siteAnalytics.devices.title': "접속 장치",
  'pages.siteAnalytics.devices.center': "총 방문자",
  'pages.siteAnalytics.devices.tip': "방문자 기준 비율입니다. 앱은 새 버전이 설치된 기기부터 집계됩니다.",

  'pages.siteAnalytics.topPages.title': "인기 페이지 TOP 10",
  'pages.siteAnalytics.topPages.col.page': "페이지명",
  'pages.siteAnalytics.topPages.col.pv': "PV",
  'pages.siteAnalytics.topPages.col.uv': "UV",
  'pages.siteAnalytics.topPages.col.avgDwell': "평균 체류",
  'pages.siteAnalytics.topPages.col.bounceRate': "이탈률",
  'pages.siteAnalytics.topPages.bounceTip': "이 페이지로 들어온 방문 가운데 다른 페이지를 보지 않고 끝난 비율입니다.",

  'pages.siteAnalytics.modules.title': "페이지 클릭 데이터",
  'pages.siteAnalytics.modules.col.module': "클릭 모듈",
  'pages.siteAnalytics.modules.col.impressions': "노출수",
  'pages.siteAnalytics.modules.col.clicks': "클릭수",
  'pages.siteAnalytics.modules.col.ctr': "CTR",
  'pages.siteAnalytics.modules.tip': "노출은 웹에서만 잽니다(영역이 화면에 절반 이상, 1초 넘게 보이면 1회). CTR은 웹 방문의 클릭 ÷ 노출이고, 클릭수에는 앱 버튼 클릭도 들어 있습니다.",

  'pages.siteAnalytics.funnel.title': "구매 전환 퍼널",
  'pages.siteAnalytics.funnel.desc': "상품 조회부터 결제까지 단계별 방문자 수와 첫 단계 대비 비율입니다.",
  'pages.siteAnalytics.funnel.tip': "뒤 단계에 도달한 방문자는 앞 단계에도 포함합니다. 주문 생성과 결제 완료는 방문 중에 만든 실제 주문으로 세며, 나중에 입금된 주문도 결제 완료로 잡힙니다. 비회원 구매 링크 주문은 포함되지 않습니다.",
  'pages.siteAnalytics.funnel.stepRate': "이전 단계 대비",
  'pages.siteAnalytics.funnel.step.list': "상품 목록/검색",
  'pages.siteAnalytics.funnel.step.detail': "상품 상세",
  'pages.siteAnalytics.funnel.step.cart': "장바구니",
  'pages.siteAnalytics.funnel.step.checkout': "결제 시작",
  'pages.siteAnalytics.funnel.step.order': "주문 생성",
  'pages.siteAnalytics.funnel.step.paid': "결제 완료",

  'pages.siteAnalytics.page.home': "홈",
  'pages.siteAnalytics.page.overseas': "해외직구",
  'pages.siteAnalytics.page.mall': "자사몰",
  'pages.siteAnalytics.page.live': "라이브",
  'pages.siteAnalytics.page.search': "검색",
  'pages.siteAnalytics.page.image_search': "이미지 검색",
  'pages.siteAnalytics.page.category': "카테고리",
  'pages.siteAnalytics.page.product': "상품 상세",
  'pages.siteAnalytics.page.cart': "장바구니",
  'pages.siteAnalytics.page.checkout': "주문서(결제 시작)",
  'pages.siteAnalytics.page.checkout_payment': "결제 진행",
  'pages.siteAnalytics.page.order_complete': "주문 완료 화면",
  'pages.siteAnalytics.page.mall_store': "스토어",
  'pages.siteAnalytics.page.live_products': "라이브 상품 목록",
  'pages.siteAnalytics.page.live_search': "라이브 검색",
  'pages.siteAnalytics.page.live_seller': "셀러 페이지",
  'pages.siteAnalytics.page.shop': "판매자 상점",
  'pages.siteAnalytics.page.picks': "추천 상품",
  'pages.siteAnalytics.page.share_rewards': "공유 리워드 안내",
  'pages.siteAnalytics.page.promo_video': "홍보 영상",
  'pages.siteAnalytics.page.mypage': "마이페이지",
  'pages.siteAnalytics.page.mypage_order': "마이페이지 주문",
  'pages.siteAnalytics.page.guest_order': "비회원 주문 조회",
  'pages.siteAnalytics.page.guest_buy': "비회원 구매 링크",
  'pages.siteAnalytics.page.message': "메시지·문의",
  'pages.siteAnalytics.page.help': "고객센터",
  'pages.siteAnalytics.page.auth': "로그인·가입",
  'pages.siteAnalytics.page.info': "회사·약관",
  'pages.siteAnalytics.page.other': "기타",

  'pages.siteAnalytics.module.main_banner': "메인 배너",
  'pages.siteAnalytics.module.product_card': "상품 카드",
  'pages.siteAnalytics.module.category_icon': "카테고리 아이콘",
  'pages.siteAnalytics.module.store_area': "추천 스토어 영역",
  'pages.siteAnalytics.module.live_area': "라이브 영역",
  'pages.siteAnalytics.module.market_area': "쇼핑몰 영역",
  'pages.siteAnalytics.module.event_banner': "이벤트 배너",
  'pages.siteAnalytics.module.search_button': "검색 버튼",
  'pages.siteAnalytics.module.cart_button': "장바구니 버튼",
  'pages.siteAnalytics.module.buy_now_button': "바로구매 버튼",

  'pages.siteAnalytics.realtime.live': "실시간 업데이트 중",
  'pages.siteAnalytics.realtime.autoRefresh': "10초 자동 새로고침",
  'pages.siteAnalytics.realtime.sampledAt': "{time} 기준",
  'pages.siteAnalytics.realtime.unavailable': "실시간 접속 정보를 읽을 수 없습니다(접속 기록 저장소 연결 문제). 아래 숫자는 접속자가 없다는 뜻이 아닙니다.",
  'pages.siteAnalytics.realtime.kpi.current': "현재 접속자 수",
  'pages.siteAnalytics.realtime.kpi.current.tip': "최근 1분 안에 화면이 열려 있던 방문자입니다. 가려진 탭은 1분이 지나면 빠집니다.",
  'pages.siteAnalytics.realtime.kpi.todayVisitors': "오늘 방문자 수",
  'pages.siteAnalytics.realtime.kpi.todayPageviews': "오늘 페이지뷰",
  'pages.siteAnalytics.realtime.kpi.mobileShare': "모바일 접속 비율",
  'pages.siteAnalytics.realtime.kpi.mobileShare.tip': "지금 접속자 가운데 PC 브라우저가 아닌 비율(모바일 브라우저 + 앱)입니다.",
  'pages.siteAnalytics.realtime.kpi.avgDwell': "평균 체류 시간",
  'pages.siteAnalytics.realtime.vs5min': "5분 전 대비",
  'pages.siteAnalytics.realtime.vsYesterday': "전일 동시간 대비",
  'pages.siteAnalytics.realtime.pcShare': "PC {rate}",

  'pages.siteAnalytics.realtime.chart.title': "실시간 접속자 수 · 최근 1시간",
  'pages.siteAnalytics.realtime.chart.summary': "현재 {current}명 · 최고 {peak}명",
  'pages.siteAnalytics.realtime.chart.series': "접속자",
  'pages.siteAnalytics.realtime.devices.title': "접속 디바이스",
  'pages.siteAnalytics.realtime.devices.center': "접속자",
  'pages.siteAnalytics.realtime.topPages.title': "현재 많이 보는 페이지 TOP 5",
  'pages.siteAnalytics.realtime.topPages.note': "새 버전 이전의 앱은 보고 있는 화면을 알려 주지 않아 여기에 잡히지 않습니다.",

  'pages.siteAnalytics.realtime.list.title': "현재 접속 중 사용자 목록",
  'pages.siteAnalytics.realtime.list.total': "총 {n}명",
  'pages.siteAnalytics.realtime.list.truncated': "접속자가 많아 최근 접속 {n}명만 보여 줍니다.",
  'pages.siteAnalytics.realtime.list.search': "ID, IP, 국가, 브라우저, 페이지 검색",
  'pages.siteAnalytics.realtime.chip.all': "전체",
  'pages.siteAnalytics.realtime.chip.member': "회원",
  'pages.siteAnalytics.realtime.chip.guest': "비회원",
  'pages.siteAnalytics.realtime.chip.mobile': "모바일",
  'pages.siteAnalytics.realtime.chip.pc': "PC",
  'pages.siteAnalytics.realtime.chip.kr': "한국",
  'pages.siteAnalytics.realtime.chip.foreign': "해외",
  'pages.siteAnalytics.realtime.col.connectedAt': "접속 시각",
  'pages.siteAnalytics.realtime.col.visitor': "방문자 ID",
  'pages.siteAnalytics.realtime.col.nickname': "회원/닉네임",
  'pages.siteAnalytics.realtime.col.ip': "IP 주소",
  'pages.siteAnalytics.realtime.col.country': "국가",
  'pages.siteAnalytics.realtime.col.device': "기기",
  'pages.siteAnalytics.realtime.col.browser': "브라우저",
  'pages.siteAnalytics.realtime.col.page': "현재 페이지",
  'pages.siteAnalytics.realtime.col.duration': "체류 시간",
  'pages.siteAnalytics.realtime.col.status': "상태",
  'pages.siteAnalytics.realtime.status.active': "접속중",
  'pages.siteAnalytics.realtime.status.idle': "대기",
  'pages.siteAnalytics.realtime.export.sheet': "실시간 접속자",
  'pages.siteAnalytics.realtime.export.empty': "내보낼 접속자가 없습니다.",
};
